/* 루미나 화면 층 신작 — 블랙 HomePage.jsx BlackGameSlideRow(추천게임 행)의 데이터·클릭·빈 목록 규칙 그대로, 표현만 시안 "다크 구역 + 세로 흐름 2열"로.
   시안 실측: 열 2개(216px)가 반대 방향으로 초당 35px 끊김 없이 순환. 각 열은 목록을 2벌 이어 붙여 한 벌 높이에서 되감고,
   열 2는 반 바퀴 어긋나게 시작한다. 움직임 최소화 설정이면 정지.
   WHY: SPEC §2 — 목록(recommendedGames: 관리자 '추천' 태그만, 0건이면 부모가 미렌더)·클릭 실행은 부모 로직 그대로. */
import React, { useEffect, useRef } from 'react';
import { gameThumbSrc, gameDisplayName, onThumbError, prefersReducedMotion, onEnterOrSpace } from './homeShared';
import { DecorBubbles } from './LuminaDecor';

const RECO_SPEED = 35 / 1000;   // px/ms (시안 실측 70px/2s)
const MIN_ITEMS = 6;            // 한 벌이 열 높이(700px)를 채우도록 목록을 반복한다(같은 게임을 다시 그릴 뿐)

/* desc: 제목 아래 설명 한 줄(관리자 '홈 문구 > 추천게임', 시안 .reco .left .sub) — 비면 그리지 않는다
   decorBubble: 방울 장식 그림(관리자 '장식 그림 > 방울', 참고 사이트 coming-soon 구간 방울 자리) — 비면 없음 */
const RecoFlow = ({ games, title, desc, decorBubble, onCardClick }) => {
  const trackRefs = useRef([]);
  const st = useRef({ cols: [], last: null, raf: 0 });

  const reps = Math.max(1, Math.ceil(MIN_ITEMS / Math.max(1, games.length)));
  const list = [];
  for (let r = 0; r < reps; r++) games.forEach((g) => list.push(g));
  const half = Math.floor(list.length / 2);
  const colLists = [list, list.slice(half).concat(list.slice(0, half))];   // 열 2는 반 바퀴 어긋남
  const bgSrc = games.length ? gameThumbSrc(games[0]) : '';

  useEffect(() => {
    const s = st.current;
    const reduce = prefersReducedMotion();
    s.cols = trackRefs.current.map((track, ci) => ({ track, dir: ci === 0 ? 1 : -1, pos: 0, one: 0 }));
    const measure = () => s.cols.forEach((c) => { if (c.track) c.one = c.track.scrollHeight / 2 + 12; });   // 한 벌 높이(+gap 절반 보정)
    const paint = () => s.cols.forEach((c) => { if (c.track) c.track.style.transform = `translateY(${c.pos.toFixed(1)}px)`; });
    measure();
    if (s.cols[0]) s.cols[0].pos = -1;
    if (s.cols[1]) s.cols[1].pos = -s.cols[1].one * 0.5;
    paint();
    const tick = (now) => {
      if (s.last != null && !reduce) {
        const dt = now - s.last;
        s.cols.forEach((c) => {
          if (!c.one || !c.track) return;
          c.pos += c.dir * RECO_SPEED * dt;
          if (c.pos > 0) c.pos -= c.one;
          if (c.pos < -c.one) c.pos += c.one;
        });
        paint();
      }
      s.last = now;
      s.raf = requestAnimationFrame(tick);
    };
    s.last = null;
    s.raf = requestAnimationFrame(tick);
    window.addEventListener('resize', measure);
    return () => {
      cancelAnimationFrame(s.raf);
      window.removeEventListener('resize', measure);
    };
  }, [list.length]);

  if (!games.length) return null;

  return (
    <section className="band reco" data-block="black-recommended-games">
      <div className="clip">
        <div className="bgimg" style={bgSrc ? { backgroundImage: `url("${bgSrc}")` } : undefined}></div>
        <div className="ov"></div>
      </div>
      <DecorBubbles bubble={decorBubble} variant="reco" />
      <div className="in"><div className="container"><div className="grid">
        <div className="left">
          <h2 className="heading-2"><span>{title}</span></h2>
          {desc && <p className="sub">{desc}</p>}
        </div>
        <div className="reco-cols">
          {colLists.map((col, ci) => (
            <div className="reco-col" key={ci}>
              <div className="reco-track" ref={(el) => { trackRefs.current[ci] = el; }}>
                {col.concat(col).map((game, idx) => {
                  const name = gameDisplayName(game);
                  return (
                    <div className="it" key={`${ci}-${idx}`} role="button" tabIndex={0} onClick={() => onCardClick(game)} onKeyDown={onEnterOrSpace(() => onCardClick(game))}>
                      <img src={gameThumbSrc(game)} alt={name} loading="lazy" draggable={false} onError={onThumbError} />
                      <b>{name}</b>
                      <span className="rel">추천</span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div></div></div>
    </section>
  );
};

export default RecoFlow;
